export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function api<T>(url: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  if (!(options.body instanceof FormData) && options.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const response = await fetch(url, { ...options, headers, credentials: "same-origin" });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new ApiError(payload.error || "请求失败，请稍后重试", response.status);
  return payload as T;
}

export function jsonBody(value: unknown): RequestInit {
  return { body: JSON.stringify(value) };
}

export function currency(amount: number, code = "USD") {
  return new Intl.NumberFormat("zh-CN", { style: "currency", currency: code, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(amount);
}

export function shortDate(value?: string | null) {
  if (!value) return "-";
  return new Intl.DateTimeFormat("zh-CN", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(value));
}

// Public visual assets should be fetched directly from OSS. The application
// proxy remains a fallback for legacy/private-compatible URLs.
export function publicAssetUrl(value?: string | null) {
  if (!value) return "";
  if (value.startsWith("/api/public-assets/") || value.startsWith("/site-assets/") || value.startsWith("/assets/")) return value;
  return value;
}
